import { MiscUtil } from '../miscUtil'

export async function validateDqsService(url) {
    if (url.indexOf('?') > 0) {
        url += '&SERVICE=DataQueryService'
    } else {
        url += '?SERVICE=DataQueryService'
    }
    url += '&REQUEST=Query&version=1.0.0'

    return MiscUtil.fetchWithPorxy(url)
}

export async function getDqsOptions(url) {
    if (url.indexOf('?') > 0) {
        url += '&SERVICE=DataQueryService'
    } else {
        url += '?SERVICE=DataQueryService'
    }
    url += '&REQUEST=Query&version=1.0.0'

    return MiscUtil.fetchWithPorxy(url).then(response => {
        return JSON.parse(response.features[0].attributes.chartOption)
    })
}
/**
 * dqs服务查询（图表定制服务）
 * @param {String} url
 * @param {Array} colFilter
 */
export async function queryDQS(url, colFilter) {
    if (url.indexOf('?') > 0) {
        url += '&SERVICE=DataQueryService'
    } else {
        url += '?SERVICE=DataQueryService'
    }
    let colFilterString = colFilter.join(',')
    url =
        url +
        '&REQUEST=Query&version=1.0.0&REQUEST=Query&COLFILTER=' +
        colFilterString
    return MiscUtil.fetchWithPorxy(url)
}
